module.exports = __webpack_public_path__ + "img/ㅅㅡㅋㅡㄹㅣㄴㅅㅑㅅ 2020-08-24 ㅇㅗㅎㅜ 4.47.41@3x.49e509a.png";